import { render, staticRenderFns } from "./depressionTest.vue?vue&type=template&id=61b1f960&scoped=true&"
import script from "./depressionTest.vue?vue&type=script&lang=js&"
export * from "./depressionTest.vue?vue&type=script&lang=js&"
import style0 from "./depressionTest.vue?vue&type=style&index=0&id=61b1f960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b1f960",
  null
  
)

export default component.exports